import { useRouteError } from "react-router-dom";
import { ErrorFlag } from "../../components/error-flag/ErrorFlag";
import { Flex } from "../../components/flex/Flex.Parts";
import { NormalizedException } from "../../utils/error.utils";
import { Props } from "./GeneralError.Parts";

export const GeneralErrorPage = ({ error }: Props) => {
  const routeError = useRouteError();
  const normalizedError = new NormalizedException(error ?? routeError);

  return (
    <Flex $flow="column" $align="center" $fullHeight>
      <ErrorFlag message={normalizedError.message} />
    </Flex>
  );
};
